import type { FC, PropsWithChildren } from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

import useAccount from "@hooks/useAccount";
import useMediaQuery from "@hooks/useMediaQuery";
import { useToggle } from "rooks";

import Header from "@components/Header";
import Sidebar from "@components/Sidebar";
import WalletDrawer from "@components/WalletDrawer";

const DefaultLayout: FC<PropsWithChildren<any>> = ({ children }) => {
	const [openMenuDrawer, toggleMenuDrawer] = useToggle(false);
	const [openWalletDrawer, toggleWalletDrawer] = useToggle(false);
	const { isLargeOrLower: isMobile } = useMediaQuery();
	const { assumedAccount, realAccount } = useAccount();

	return (
		<Box
			sx={{
				display: "flex",
				height: "100vh",
				width: "100vw",
			}}
		>
			<Sidebar open={openMenuDrawer} toggleOpen={toggleMenuDrawer} />
			<Box component="main" sx={{ overflowX: "hidden", width: "100%" }}>
				<Header
					open={openMenuDrawer}
					// @ts-expect-error: TODO
					handleDrawerOpen={() => toggleMenuDrawer(!openMenuDrawer)}
					showMenu={isMobile}
				/>
				{assumedAccount && realAccount !== assumedAccount && (
					<Box
						marginBottom={2}
						bgcolor="yellow"
						color="red"
						fontWeight="bold"
						p={1}
						textAlign="center"
					>
						Assumed account: {assumedAccount}
					</Box>
				)}
				<Container
					maxWidth="xl"
					sx={{ maxWidth: "1940px !important", padding: 2 }}
				>
					{children}
				</Container>
			</Box>
			<WalletDrawer open={openWalletDrawer} toggleOpen={toggleWalletDrawer} />
		</Box>
	);
};

export default DefaultLayout;
